import { CUBE } from '@/configuration'

export default {
  IM: {
    APPID: CUBE.im.appid,
    ACCOUNTTYPE: '36862',
    isLogOn: false,
    ADMIN_ACCOUNT: 'admin1'
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/call-center/config.js